import { Link } from "react-router-dom";
import { useFetch } from "../hooks/useFetch";
import { ErrorBanner } from "../components/ErrorBanner";
import type { StudentSubmissionRow } from "../api/types";
import {
  EmptyState,
  LoadingState,
  PageHeader,
  StatusBadge,
} from "../components/ui";

interface ListResponse {
  submissions: StudentSubmissionRow[];
}

export function StudentResultsPage() {
  const { data, loading, error } = useFetch<ListResponse>(
    "/student/submissions",
  );

  return (
    <section>
      <PageHeader
        title="My results"
        subtitle="All your submitted and graded tests."
        actions={<Link to="/student">← Back to dashboard</Link>}
      />
      <ErrorBanner error={error} />
      {loading ? (
        <LoadingState />
      ) : data && data.submissions.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th>Test</th>
              <th>Status</th>
              <th>Submitted</th>
              <th>Graded</th>
              <th>Auto</th>
              <th>Manual</th>
              <th>Final</th>
              <th>Max</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.submissions.map((s) => (
              <tr key={s.id}>
                <td>{s.test_title}</td>
                <td>
                  <StatusBadge status={s.status} />
                  {s.auto_submitted_at && (
                    <div>
                      <small>(auto-submitted by timer)</small>
                    </div>
                  )}
                </td>
                <td>{s.submitted_at ?? "—"}</td>
                <td>{s.graded_at ?? "—"}</td>
                <td>{s.total_auto_score ?? "—"}</td>
                <td>{s.total_manual_score ?? "—"}</td>
                <td>
                  <strong>{s.final_score ?? "—"}</strong>
                </td>
                <td>{s.max_score}</td>
                <td>
                  <Link to={`/student/results/${s.id}`}>Open</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <EmptyState
          title="You have not submitted any tests yet"
          hint="Your results will appear here after you submit a test."
        />
      )}
    </section>
  );
}
